import { render } from "./ProductCategoryCreateComponent.vue?vue&type=template&id=c770ccf2"
import script from "./ProductCategoryCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductCategory/ProductCategoryCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c770ccf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c770ccf2', __exports__)) {
    api.reload('c770ccf2', __exports__)
  }
  
  module.hot.accept("./ProductCategoryCreateComponent.vue?vue&type=template&id=c770ccf2", () => {
    api.rerender('c770ccf2', render)
  })

}


export default __exports__